import { createFileRoute } from "@tanstack/react-router";
import { loginHead, validateLoginSearch } from "~/lib/login-search.ts";
import { FlirtMachineAdminLogin } from "./index.tsx";

/**
 * Catch-all beneath the FlirtMachine admin login door. Clerk's `<SignIn
 * routing="path" path="/admin/login">` drives its own steps at sub-paths of
 * the door — `/admin/login/factor-one` (email code / password),
 * `/admin/login/factor-two`, `/admin/login/verify`, … — and TanStack needs a
 * route there or the step renders the site 404. This is the "TanStack Router
 * catch-all route" Clerk's TanStack Start guide requires for the sign-in
 * page. It ranks below the exact `index.tsx` and the static
 * `sso-callback.tsx`, so it only catches Clerk's own steps.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/flirtmachine/admin/login/$")({
  validateSearch: validateLoginSearch,
  head: () => loginHead("FlirtMachine"),
  component: FlirtMachineAdminLogin,
});
